
import { supabase } from '@/integrations/supabase/client';
import { logActivityEvent } from '@/services/activity/activityLogService';

export const deleteMenuItem = async (itemId: string, storeId: string): Promise<boolean> => {
  // Fetch the menu item details before deleting
  const { data: menuItemData, error: fetchError } = await supabase
    .from('menu_items')
    .select('*')
    .eq('id', itemId)
    .single();

  if (fetchError) {
    console.error("Error fetching menu item before deletion:", fetchError);
    throw fetchError;
  }

  const { error } = await supabase
    .from('menu_items')
    .delete()
    .eq('id', itemId);
  
  if (error) {
    console.error("Error deleting menu item:", error);
    throw error;
  }

  // Log the deletion
  await logActivityEvent({
    entity_type: 'menu_item',
    entity_id: itemId,
    user_name: 'Admin',
    action: 'menu_item_deleted',
    details: {
      name: menuItemData.name,
      price: menuItemData.price
    },
    store_id: storeId
  });
  
  return true;
};
